import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

const http = axios.create({
    baseURL: "https://trainyourbrain.projekte.fh-hagenberg.at/api/",
    headers: {
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
    },
    maxBodyLength: 25 * 1024 * 1024,
    maxContentLength: 25 * 1024 * 1024
});

let sessionExpired = false;

const handleSessionExpiry = () => {
    if (sessionExpired) return;
    sessionExpired = true;

    Cookies.remove("token");
    Cookies.remove("username");
    toast.info("Ihre Session ist abgelaufen. Sie müssen sich bitte neu einloggen.");
    window.location.href = "/#/login";
};

// Helper to decode and validate token expiry
const isTokenValid = (token: string): boolean => {
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const currentTime = Math.floor(Date.now() / 1000);
        return payload.exp > currentTime;
    } catch {
        return false;
    }
};

http.interceptors.request.use(
    (config) => {
        const token = Cookies.get("token");
        const isAuthRoute = config.url?.includes("/useraccount/getByLoginData");

        if (!isAuthRoute && (!token || !isTokenValid(token))) {
            handleSessionExpiry();
            const controller = new AbortController();   //silently abort
            controller.abort();
            config.signal = controller.signal;
            return config;
        }

        config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    (error: any) => {
        return Promise.reject(error);
    }
);

// RESPONSE interceptor — catches 401s from Spring
http.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
            return new Promise(() => {}); // swallow silently
        }

        const isAuthRoute = error.config?.url?.includes("/useraccount/getByLoginData");
        if (isAuthRoute) {
            // Wrong password — let the error bubble up to the caller
            return Promise.reject(error);
        }

        if (error.response?.status === 401 || error.response?.status === 403) {
            handleSessionExpiry();
            return new Promise(() => {});
        }
        return Promise.reject(error);
    }
);

export default http;